import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import { MarvTagComponent, MarvImgComponent } from '@marv/components';
import { PhotoGalleryItem, RetailerLogo, RetailerLogoComponent } from '@app/components';
import { EpochToStringPipe } from '@app/pipes';
import { MissionTypeService } from '@app/services';

@Component({
    selector: 'app-photo-gallery-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        forwardRef(() => MarvTagComponent), forwardRef(() => MarvImgComponent),
        EpochToStringPipe, forwardRef(() => RetailerLogoComponent)
    ]
})
export class PhotoGalleryItemComponent  implements OnInit {

    @Input({alias : 'photo', required : true}) photo: PhotoGalleryItem;  
    @Input({alias : 'size', required : false}) sizePhoto: 'small'|'medium'|'big' = 'medium';
    @Input({alias : 'displayStore', required : false}) displayStore: boolean = true;
    @Input({alias : 'displayOperation', required : false}) displayOperation: boolean = true;
    @Output() onSelectPhoto = new EventEmitter<PhotoGalleryItem>();
    
    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {}
    
    getRetailerLogo(): RetailerLogo{
        return new RetailerLogo(this.photo.retailer.name);
    }
    
    selectPhoto(){
        this.onSelectPhoto.emit(this.photo);
    }
}
